<template>
  
  <div class="sixteen wide column">
    <div class="ui segment">
      <h4 class="ui dividing header">Mensagens</h4>
      <form class="ui form">
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Observações</label>
            <textarea rows="3" v-model="comments" @blur="onChange()"></textarea>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script>

  import cleanSpecialChars from "@/utils/clean-special-chars"

  export default {

    data() {
      return {
        comments: "",
      }
    },
    
    props: ["quotation", "isCreating", "isUpdating"],

    created() {

      if (this.isUpdating)
        this.comments = this.quotation.comments
    },

    methods: {

      onChange() {
        this.$emit("onChange", cleanSpecialChars(this.comments))
      },
    },
  }
</script>

